import { createSlice } from '@reduxjs/toolkit';
import { deleteDocs, getDocs, searchDocs, uploadDocs } from './docsActions';

const initialState = {
  loading: false,
  docs: [],
  error: null,
  success: false,
};

const docsSlice = createSlice({
  name: 'docs',
  initialState,
  reducers: {},
  extraReducers: {
    // get docs
    [getDocs.pending]: state => {
      state.loading = true;
    },
    [getDocs.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.docs = payload.data
        ? payload.data.sort(
            (a, b) =>
              new Date(b.created_at).getTime() -
              new Date(a.created_at).getTime()
          )
        : [];
    },
    [getDocs.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // search docs
    [searchDocs.pending]: state => {
      state.loading = true;
    },
    [searchDocs.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.docs = payload.data
        ? payload.data.sort(
            (a, b) =>
              new Date(b.created_at).getTime() -
              new Date(a.created_at).getTime()
          )
        : [];
    },
    [searchDocs.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // upload docs
    // [uploadDocs.pending]: state => {
    //   state.loading = true;
    // },
    [uploadDocs.fulfilled]: (state, { payload }) => {
      state.loading = false;
      // state.docs = payload.data;
    },
    [uploadDocs.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    // delete docs
    // [deleteDocs.pending]: state => {
    //   state.loading = true;
    // },
    [deleteDocs.fulfilled]: (state, { payload }) => {
      state.loading = false;
      // state.docs = payload.data;
    },
    [deleteDocs.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export default docsSlice.reducer;
